import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from "./ConditionVisibleControls";

export default class UnstructuredEventDataProperty extends ConditionProperty {
  static override readonly label: string = 'Unstructured event data property';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: true, fieldIndex: false };
  static override readonly type: number = 3;

  buildDescription(): string {
    return `Unstructured [${this.condition.options.path}] in data ${this.getOperatorLabel()} [${this.condition.value}]`;
  }
}
